// import React, { useCallback } from 'react';
import { RegistrationPageStyled } from './registration.page.styled';
import bookingRegistration from '../../../assets/auth/booking_room_registration.png';
import i18n from '../../../translations/strings';
import Button from '../../../components/base/button/button';
// import { ButtonVariant } from '../../../components/base/button/constants';
import { useLocation, useNavigate } from 'react-router-dom';
// import {
//   IResolveParams,
//   LoginSocialFacebook,
//   LoginSocialGoogle,
// } from 'reactjs-social-login';
// import { useDispatch } from 'react-redux';
// import { userSetDataAction } from '../../../store/user.store';
// import { registrationCustomerErrorAction } from '../../../store/auth/registration.store';

const RegistrationPage = () => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const { state } = useLocation();

  // const onSocialResolveLogin = useCallback((provider: any, data: any) => {
  //   let user;

  //   if (provider === 'facebook') {
  //     user = {
  //       email: data.email,
  //       first_name: data.first_name,
  //       last_name: data.last_name,
  //       access_token: data.accessToken,
  //       facebook_id: data.id,
  //     };
  //   } else if (provider === 'google') {
  //     user = {
  //       email: data.email,
  //       first_name: data.given_name,
  //       last_name: data.family_name,
  //       access_token: data.access_token,
  //       google_id: data.sub,
  //     };
  //   }
  //   dispatch(userSetDataAction(user));
  //   navigate('/registration-customer', {
  //     state: {
  //       isSocialRegistration: true,
  //       provider: provider,
  //       isBookingFromLandingPage: state?.isBookingFromLandingPage,
  //     },
  //   });
  // }, []);

  return (
    <RegistrationPageStyled.Container container>
      <RegistrationPageStyled.ContainerSocials item xs={12} md={4}>
        <RegistrationPageStyled.ContainerImage>
          <RegistrationPageStyled.Image src={bookingRegistration} />
        </RegistrationPageStyled.ContainerImage>
        <RegistrationPageStyled.Text>
          {state?.isBookingFromLandingPage
            ? i18n.t('registration.registrationWithBookingTitle')
            : i18n.t('registration.completeSignUp')}
        </RegistrationPageStyled.Text>
        {/* <RegistrationPageStyled.ContainerButtonsSocial> */}
        {/* <RegistrationPageStyled.Separator /> */}
        {/* <LoginSocialGoogle
            client_id={process.env.REACT_APP_CLIENT_ID_GOOGLE || ''}
            redirect_uri={process.env.REACT_APP_REDIRECT_URI}
            scope="openid profile email"
            discoveryDocs="claims_supported"
            access_type="offline"
            onResolve={({ provider, data }: IResolveParams) => {
              onSocialResolveLogin(provider, data);
            }}
            onReject={err => {
              dispatch(
                registrationCustomerErrorAction(
                  i18n.t('apiError.error_generic'),
                ),
              );
            }}
          >
            <Button
              variant={ButtonVariant.Google}
              onClick={() => null}
              label={i18n.t('registration.signupWithGoogle')}
            />
          </LoginSocialGoogle> */}
        {/* <RegistrationPageStyled.Separator /> */}
        {/* <LoginSocialFacebook
            appId={process.env.REACT_APP_APP_ID_FACEBOOK || ''}
            fieldsProfile={
              'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
            }
            redirect_uri={process.env.REACT_APP_REDIRECT_URI}
            onResolve={({ provider, data }: IResolveParams) => {
              onSocialResolveLogin(provider, data);
            }}
            onReject={err => {
              dispatch(
                registrationCustomerErrorAction(
                  i18n.t('apiError.error_generic'),
                ),
              );
            }}
          >
            <Button
              variant={ButtonVariant.Facebook}
              onClick={() => null}
              label={i18n.t('registration.signupWithFacebook')}
            />
          </LoginSocialFacebook> */}
        {/* <RegistrationPageStyled.Separator /> */}
        <RegistrationPageStyled.ContainerButton>
          <Button
            onClick={() =>
              navigate('/registration-customer', {
                state: {
                  isBookingFromLandingPage: state?.isBookingFromLandingPage,
                },
              })
            }
            label={i18n.t('registration.signUpEmail')}
          />
        </RegistrationPageStyled.ContainerButton>
        {/* </RegistrationPageStyled.ContainerButtonsSocial> */}
      </RegistrationPageStyled.ContainerSocials>
    </RegistrationPageStyled.Container>
  );
};

export default RegistrationPage;
